import { findIndex } from 'lodash';

const initialState = {
  isRolesFetching: false,
  isPermissionsFetching: false,
  isRoleUpserting: false,
  snackbarMessage: null,
  roles: [],
  permissions: [],
  hasError: false,
};

export const roles = (state = initialState, action) => {
  switch (action.type) {
    case 'CLEAR_STATE':
      return initialState;
    case 'ROLES_REQUEST':
      return {
        ...state,
        error: null,
        isRolesFetching: true,
      };
    case 'ROLES_REQUEST_SUCCESS':
      return {
        ...state,
        roles: action.data,
        hasError: false,
        isRolesFetching: false,
      };
    case 'ROLES_REQUEST_ERROR':
      return {
        ...state,
        hasError: true,
        snackbarMessage: action.error,
        isRolesFetching: false,
      };
    case 'PERMISSIONS_REQUEST':
      return {
        ...state,
        hasError: false,
        isPermissionsFetching: true,
      };
    case 'PERMISSIONS_REQUEST_SUCCESS':
      return {
        ...state,
        permissions: action.data,
        hasError: false,
        isPermissionsFetching: false,
      };
    case 'PERMISSIONS_REQUEST_ERROR':
      return {
        ...state,
        snackbarMessage: action.error,
        hasError: true,
        isPermissionsFetching: false,
      };
    case 'CREATE_ROLE_REQUEST':
    case 'EDIT_ROLE_REQUEST':
      return {
        ...state,
        hasError: false,
        snackbarMessage: null,
        isRoleUpserting: true,
      };
    case 'CREATE_ROLE_REQUEST_SUCCESS':
    case 'EDIT_ROLE_REQUEST_SUCCESS': {
      const index = findIndex(state.roles, ({ uuid }) => action.role.uuid === uuid);

      const newRoles = [
        ...state.roles.slice(0, index),
        action.role,
        ...state.roles.slice(index + 1),
      ];

      const actionMessage = action.type === 'CREATE_ROLE_REQUEST_SUCCESS' ? 'created' : 'updated';

      return {
        ...state,
        roles: newRoles,
        hasError: false,
        isRoleUpserting: false,
        snackbarMessage: `The role has been ${actionMessage}.`,
      };
    }
    case 'CREATE_ROLE_REQUEST_ERROR':
    case 'EDIT_ROLE_REQUEST_ERROR':
      return {
        ...state,
        snackbarMessage: action.error,
        hasError: true,
        isRoleUpserting: false,
      };
    case 'HIDE_ROLES_SNACKBAR':
      return {
        ...state,
        snackbarMessage: null,
        hasError: false
      };
    case 'CLEAR_ROLES':
      return {
        ...state,
        roles: []
      };
    default:
      return state;
  }
};
